import { render, staticRenderFns } from "./Component-Tasksummary.vue?vue&type=template&id=612f23af"
import script from "./Component-Tasksummary.vue?vue&type=script&lang=js"
export * from "./Component-Tasksummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports